const CSRF_COOKIE = '__c_token__'

export function getCsrfCookie() {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${CSRF_COOKIE}=`)
  if (parts.length === 2) return parts.pop().split(';').shift()
  return undefined
}

export async function getCsrfToken() {
  const res = await fetch(`${import.meta.env.VITE_API}auth/csrf-token`, {
    credentials: 'include',
  });
  const data = await res.json();
  return data.csrfToken;
}
